import { Component, Inject, OnInit } from "@angular/core";
import {
  ProductOptions,
  CategoryOptions,
} from "app/_models/optionsList/options";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { OptionslistService } from "app/_services/optionslist.service";
import { CrudSubcategoryService } from "app/_services/MasterCrudOps/crud-subcategory.service";
declare const swal: any;

@Component({
  selector: "app-add-sub-category",
  templateUrl: "./add-sub-category.component.html",
  styleUrls: ["./add-sub-category.component.css"],
})
export class AddSubCategoryComponent implements OnInit {
  addSubCategoryForm: UntypedFormGroup;
  productOptions: ProductOptions[] = [];
  categoryOptions: CategoryOptions[] = [];
  pageNumber: number;
  pageSize: number;

  constructor(
    private readonly toastr: ToastrService,
    private readonly dialogRef: MatDialogRef<AddSubCategoryComponent>,
    private readonly optionslistService: OptionslistService,
    private readonly crudSubcategoryService: CrudSubcategoryService,
    private readonly formBuilder: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.pageNumber = data.pageNumber;
    this.pageSize = data.pageSize;
    this.initilizeForm();
  }

  ngOnInit(): void {
    this.initilizeForm();
    this.optionslistService.getProductsOptions().subscribe((productOptions) => {
      this.productOptions = productOptions;
    });
  }

  initilizeForm() {
    this.addSubCategoryForm = this.formBuilder.group({
      description: [null, [Validators.required, Validators.maxLength(100)]],
      productId: [null, [Validators.required]],
      categoryId: [null, [Validators.required]],
      subCategoryName: [null, [Validators.required, Validators.maxLength(50)]],
    });
  }

  saveSubCategory() {
    // productId  categoryId   subCategoryName  description
    const productId = this.addSubCategoryForm.value.productId;
    const categoryId = this.addSubCategoryForm.value.categoryId;
    const subCategoryName = (
      this.addSubCategoryForm.value.subCategoryName ?? ""
    ).trim();
    const description = (
      this.addSubCategoryForm.value.description ?? ""
    ).trim();
    swal({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: "btn btn-success",
      cancelButtonClass: "btn btn-danger",
      confirmButtonText: "YES, Add IT!",
    }).then((result) => {
      if (result) {
        let model = {
          productId: productId,
          categoryId: categoryId,
          subCategoryName: subCategoryName,
          description: description
        };
        this.addSubCategory(model);
      } else {
        this.toastr.info("result not saved");
      }
    });
  }

  onSelectionchange(e: any) {
    this.optionslistService
      .getCategoryByProductOptions(e.value)
      .subscribe((categories) => {
        this.categoryOptions = categories;
      });
  }

  addSubCategory(model: any) {
    this.crudSubcategoryService.addSubCategory(model).subscribe(
      (data) => {
        if (data.didError) {
          swal({
            title: "",
            text: data.message,
            type: "error",
            confirmButtonClass: "btn btn-info",
          });
        } else {
          swal({
            title: "",
            text: data.message,
            type: "success",
            confirmButtonClass: "btn btn-info",
          });
        }
        let result = {
          status: true,
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
        };
        this.dialogRef.close(result);
      },
      (error) => {
        let errorMessage =
          error.error?.title ??
          error.error ??
          "Something went wrong. Please contact admin.";

        // Check if it's a validation error response with the `errors` object
        if (error.error?.errors) {
          const allErrors = Object.values(error.error.errors).flat(); // Flatten all error arrays
          if (allErrors.length > 0) {
            errorMessage = allErrors[0]; // Use the first validation message
          }
        } else if (typeof error.error === "string") {
          errorMessage = error.error;
        } else if (error.error?.title) {
          errorMessage = error.error.title;
        }
        swal({
          title: "",
          text: errorMessage,
          type: "error",
          confirmButtonClass: "btn btn-info",
        });
      }
    );
  }

  close() {
    let result = {
      status: true,
      pageNumber: this.pageNumber,
      pageSize: this.pageSize,
    };
    this.dialogRef.close(result);
  }
}
